import React, { useEffect, useRef, useState } from 'react';
import BottomSheet from '../../../Components/Ui/BottomSheet';
import { Box, Typography } from '@mui/material';
import { Button } from '../../../Components/MUIs';
import ComboBottomSheet from './ComboBottomSheet';
import Icon from '../../../Assets/Icon/CustomIcon';
import { styled } from '@mui/material/styles';
import { Swiper, SwiperSlide } from 'swiper/react';
import useThrottle from '../../../Hooks/useThrottle';
import { Capacitor } from '@capacitor/core';

const MAX_PHOTOS = 5;

const gubunComboData = [
  { name: '작업 재개를 승인합니다.', value: '0' },
  { name: '추후 개선하겠습니다.', value: '1' },
];

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

/**
 * 작업 재개 승인 바텀시트 (WorkEndBottomStheet 패턴)
 * - workStopUpload: { previewList, FileChange, DeletePreview, setPreviewList }
 * - 사진 업로드 후 완료 시 SaveLogic1 호출하여 저장
 */
export default function SignWorkStopBottomStheet({
  open,
  ToggleDrawer,
  SaveLogic1,
  workStopUpload,
  setWorkStopInputs,
  workStopInputs,
  mode,
}) {
  const fileInputRef = useRef(null);
  const [isComboOpen, setIsComboOpen] = useState(false);

  const handleClose = (e) => {
    setWorkStopInputs({
      solveYn: '',
      skipYn: '',
      solveComment: '',
    });
    workStopUpload?.setPreviewList?.([]);
    setIsComboOpen(false);
    ToggleDrawer('bottom', false)(e);
  };

  const [handleSign, isThrottling] = useThrottle((e) => {
    const override =
      mode === 'edit' ? { solveYn: 'Y', skipYn: 'N' } : undefined;
    SaveLogic1(override);
    ToggleDrawer('bottom', false)(e);
  }, 1000);

  useEffect(() => {
    if (open) {
      setWorkStopInputs((prev) => ({
        ...prev,
        solveYn: prev.solveYn || 'Y',
        skipYn: prev.skipYn || 'N',
      }));
    }
  }, [open, setWorkStopInputs]);

  const previewList = workStopUpload?.previewList ?? [];
  const showPhotoSection =
    mode === 'edit' ||
    (mode === 'approve' && workStopInputs.skipYn === 'N');

  return (
    <BottomSheet
      open={open}
      onClose={handleClose}
      onOpen={ToggleDrawer('bottom', true)}
      isHeaderChildren={true}
      headerText={''}
      headerChildren={
        <Typography
          sx={{ fontSize: '18px', fontWeight: 'bold', display: 'flex' }}
        >
          작업 재개를 승인합니다.
        </Typography>
      }
    >
      <Box sx={{ px: 1, minHeight: isComboOpen ? '220px' : 'auto' }}>
        <Typography style={{ color: '#918A8A', paddingBottom: '0.5rem' }}>
          {mode === 'approve' ? (
            <>
              진행된 조치 사항을 선택해주세요. <br /> 해당 내용은 기록됩니다.
            </>
          ) : (
            '개선 내용을 입력해주세요.'
          )}
        </Typography>

        {mode === 'approve' && (
          <Box sx={{ marginBottom: '16px' }}>
            <label
              style={{
                fontWeight: 'bold',
                fontSize: '16px',
                color: '#2c2c2cff',
              }}
            >
              조치 사항
            </label>
            <Box onClick={() => !isThrottling && setIsComboOpen(!isComboOpen)}>
              <ComboBottomSheet
                items={gubunComboData}
                value={workStopInputs.skipYn === 'Y' ? '1' : '0'}
                disabled={isThrottling}
                onChange={(val) => {
                  if (val === '0') {
                    setWorkStopInputs((prev) => ({
                      ...prev,
                      solveYn: 'Y',
                      skipYn: 'N',
                    }));
                  } else if (val === '1') {
                    setWorkStopInputs((prev) => ({
                      ...prev,
                      solveYn: 'Y',
                      skipYn: 'Y',
                    }));
                  }
                }}
              />
            </Box>
          </Box>
        )}

        {showPhotoSection && (
          <>
            <Typography
              sx={{
                fontSize: '16px',
                fontWeight: 'bold',
                display: 'flex',
              }}
            >
              개선 내용
            </Typography>
            <Box sx={{ display: 'flex', gap: 1, my: 2 }}>
              <Box>
                <button
                  disabled={isThrottling}
                  style={{
                    cursor: 'pointer',
                    border: '1px solid #DFD9D9',
                    borderRadius: '8px',
                    color: '#8D8787',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '14px',
                    padding: '8px 16px',
                    width: '90px',
                    height: '92px',
                  }}
                  onClick={() => {
                    if (isThrottling) return;
                    const photoCount = previewList.filter(
                      (img) => !img.deleted
                    ).length;
                    if (photoCount >= MAX_PHOTOS) return;
                    if (Capacitor.isNativePlatform()) {
                      workStopUpload?.NativeFileChange();
                    } else {
                      fileInputRef.current?.click();
                    }
                  }}
                >
                  <Icon.Camera width={40} height={40} />
                  <p>
                    {previewList.filter((img) => !img.deleted).length} / 5
                  </p>
                </button>
                <VisuallyHiddenInput
                  ref={fileInputRef}
                  type="file"
                  accept="image/*"
                  disabled={isThrottling}
                  onChange={workStopUpload?.FileChange}
                />
              </Box>

              <Box sx={{ flex: 1, width: '100%', overflow: 'hidden' }}>
                <Swiper slidesPerView="auto" spaceBetween={8}>
                  {previewList
                    .filter((img) => !img.deleted)
                    .map((item, index) => (
                      <SwiperSlide className="workinfo-slide" key={index}>
                        <Box
                          sx={{
                            position: 'relative',
                            width: '90px',
                            height: '92px',
                            border: '1px solid #DFD9D9',
                            borderRadius: '8px',
                            overflow: 'hidden',
                          }}
                        >
                          <img
                            style={{
                              width: '100%',
                              objectFit: 'cover',
                            }}
                            src={item.preview}
                            alt="img"
                          />
                          <button
                            disabled={isThrottling}
                            style={{
                              position: 'absolute',
                              top: 0,
                              right: 0,
                              border: 'none',
                              backgroundColor: 'transparent',
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              if (!isThrottling) {
                                workStopUpload?.DeletePreview?.(item);
                              }
                            }}
                          >
                            <Icon.Delete width={20} height={20} />
                          </button>
                        </Box>
                      </SwiperSlide>
                    ))}
                </Swiper>
              </Box>
            </Box>

            <textarea
              type="text"
              value={workStopInputs.solveComment || ''}
              disabled={isThrottling}
              onChange={(e) =>
                setWorkStopInputs((prev) => ({
                  ...prev,
                  solveComment: e.target.value,
                }))
              }
              style={{
                width: '100%',
                padding: '14px 16px',
                borderRadius: '8px',
                outline: 'none',
                fontSize: '16px',
                backgroundColor: '#F8F8F8',
                border: 'none',
                transition: 'border-color 0.3s ease',
                minHeight: '10rem',
                resize: 'none',
                boxSizing: 'border-box',
              }}
              placeholder="개선 내용을 입력하세요"
            />
          </>
        )}
      </Box>

      <Box
        p={1}
        bgcolor="#fff"
        sx={{
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          position: 'sticky',
          bottom: 0,
        }}
      >
        <Button
          name="완료"
          disabled={isThrottling}
          sx={{
            width: '100%',
            height: 36,
            borderRadius: '5px',
            backgroundColor: '#57B84D',
            color: '#fff',
            boxShadow: 'none',
          }}
          onClick={handleSign}
        />
      </Box>
    </BottomSheet>
  );
}
